import { render, staticRenderFns } from "./OzContainedButton.vue?vue&type=template&id=09117348&"
import script from "./OzContainedButton.vue?vue&type=script&lang=ts&"
export * from "./OzContainedButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports